<script>
export default {
    name: 'IconConnexionLight',
}
</script>
<template>
   <svg class="base-icon icon-connexion-light" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><path fill="currentColor"  d="M9.333 41.6h6.334v16h38V6.4h-38v16H9.333V3.2c0-.849.334-1.663.928-2.263A3.15 3.15 0 0 1 12.5 0h44.333c.84 0 1.646.337 2.24.937.593.6.927 1.414.927 2.263v57.6c0 .849-.334 1.663-.928 2.263-.593.6-1.399.937-2.239.937H12.5a3.15 3.15 0 0 1-2.24-.937 3.217 3.217 0 0 1-.927-2.263V41.6Zm19-12.8v-9.6L44.167 32 28.333 44.8v-9.6H3v-6.4h25.333Z"/></svg>
</template>
